import { createFileRoute } from "@tanstack/react-router";
import { CityPageBody } from "@/components/site/CityPageBody";
import { BUSINESS } from "@/components/site/constants";
import { canonical } from "@/components/site/site-config";

export const Route = createFileRoute("/roofing-company-dunnellon-fl")({
  head: () => ({
    meta: [
      { title: "Roofing Company in Dunnellon, FL | Destination Roofing" },
      { name: "description", content: `Local roofing company serving Dunnellon, FL. Roof repair, replacement, metal and shingle roofing. Free Roof Inspection & Estimate. Call ${BUSINESS.phone}.` },
      { property: "og:title", content: "Roofing Company in Dunnellon, FL" },
      { property: "og:description", content: "Family-owned roofer serving Dunnellon, FL." },
      { property: "og:url", content: canonical("/roofing-company-dunnellon-fl") },
    ],
    links: [{ rel: "canonical", href: canonical("/roofing-company-dunnellon-fl") }],
  }),
  component: () => (
    <CityPageBody
      city="Dunnellon"
      intro={
        <p>
          Dunnellon sits at the meeting point of the Withlacoochee and Rainbow Rivers, with a mix of riverfront homes, older in-town properties, and newer developments outside the historic district. Roof age and condition varies widely across the area, and each home needs a look before deciding on repair vs replacement.
        </p>
      }
      localNotes={
        <>
          <p>
            On riverfront and heavily-shaded Dunnellon homes, we regularly see moss and algae staining, water-holding valleys, and rot around chimneys and skylights. On the newer subdivisions, we tend to see storm damage and lifted shingles more than age-related wear.
          </p>
          <p>
            We service Dunnellon homeowners for roof replacement, roof repair, metal roofing, and full storm-damage claims support.
          </p>
        </>
      }
    />
  ),
});
